import React from "react";
import { useI18n } from "../i18n";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useI18n();
  return (
    <div
      className={`dv-pill p-0.5 ${className}`}
      style={{ background: "var(--paper)", border: "1px solid var(--line)" }}
      data-testid="language-switcher"
      role="group"
      aria-label="Language"
    >
      {["fr", "en"].map((l) => {
        const on = lang === l;
        return (
          <button
            key={l}
            onClick={() => setLang(l)}
            data-testid={`lang-${l}`}
            aria-pressed={on}
            className="px-2.5 py-1 rounded-full text-[11px] font-semibold font-display uppercase transition-colors"
            style={{ background: on ? "var(--ink)" : "transparent", color: on ? "#fff" : "var(--muted)" }}
          >
            {l}
          </button>
        );
      })}
    </div>
  );
};
